export class SetNewPasswordError extends Error {
  constructor(t: any) {
    super(t("User is required to set a new password!"));
    this.name = "SetNewPasswordError";
    // Set the prototype explicitly to maintain the correct prototype chain
    Object.setPrototypeOf(this, SetNewPasswordError.prototype);
  }
}
